<template>
  <div class="main-content ">
    <div class="invoice-page">
      <div class="container">
        <Step />
        <MemberInfoBar @setMember="setMember" />

        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <InvoiceBox
              title="發票資料"
              ref="invoice"
              :member="member"
            ></InvoiceBox>

            <button class="custom-btn">確認</button>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import Step from '@/components/Layouts/Step';
import { isMobile } from 'mobile-device-detect';
import MemberInfoBar from '@/components/MemberInfoBar';
import InvoiceBox from '@/components/Invoice';
import { issueInvoice } from '@/api/order';

export default {
  components: {
    Step,
    MemberInfoBar,
    InvoiceBox
  },
  data() {
    return {
      isMobile: isMobile,
      member: {}
    };
  },
  computed: {
    orderId() {
      return this.$route.params.order_id;
    }
  },
  created() {
    if (this.isMobile) {
      alert('現在是手機開啟');
      this.$router.push({ name: '歷史購買紀錄' });
    }
  },
  methods: {
    submit() {
      issueInvoice(
        {
          order_id: this.orderId,
          ...this.$refs.invoice.postData
        },
        data => {
          if (data.print_link) {
            window.open(data.print_link);
          } else {
            alert('發票連結產生失敗');
          }

          //開立發票成功回歷史購買紀錄
          this.$router.push({ name: '歷史購買紀錄' });
        }
      );
    },
    setMember(member) {
      this.member = member;
    }
  }
};
</script>
